// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"05c4eb3b","827":"641da0bd","890":"31489a86"}[chunkId] + ".chunk.js";
};